export default [
	'firstName',
	'lastName',
	'country',
	'address',
	'city',
	'state',
	'zip',
	'phoneNumber',
	'email',
	'cardNumber',
	'expirationDate',
	'cardCode'
];
